export default {
    permissionRoomsTitle: 'Title ',
    permissionRoomsEn: 'Title En',
    permissionRoomsKey: ' Key',
}